import { TOPICS, SUBGROUPS } from "./GeneralSection";
import { LOG_KEYS } from "./ProfileSettingsSection";

/**
 * Ayar aramasının KATEGORİ sözlüğü.
 *
 * Arama kutusuna yazılan metin yalnızca alan etiketlerinde değil, alanın
 * bulunduğu kategori adlarında da aranır: "kazan" yazınca Kazan Ayarı'ndaki
 * tüm alanlar, "log" yazınca log alanları, "şifre" yazınca güvenlik alanları
 * gelir. Kategori adları ekranda görünen adlarla aynıdır (bölüm sekmesi,
 * alt grup başlığı, konu başlığı).
 */

// Türkçe arama: hem sorgu hem metin aynı şekilde sadeleştirilir. Böylece
// "isitici" yazınca "Isıtıcı Ayarı" da eşleşir (klavye/diakritik farkı
// aramayı bozmasın).
const TR_FOLD = {
  ı: "i", İ: "i", i: "i", I: "i",
  ş: "s", Ş: "s",
  ğ: "g", Ğ: "g",
  ü: "u", Ü: "u",
  ö: "o", Ö: "o",
  ç: "c", Ç: "c",
};

export const fold = (text) =>
  String(text ?? "")
    .replace(/[ıİiIşŞğĞüÜöÖçÇ]/g, (ch) => TR_FOLD[ch])
    .toLowerCase();

// Veri yolundan (data ağacındaki konum) o dalın kategori adlarına.
// Bir dalın adı eşleşirse dalın TAMAMI sonuçta kalır.
const PATH_TITLES = {
  "profile.security": ["Şifre Ayarları", "Güvenlik", "Sistem"],
  "profile.settings": ["Sistem", "Genel"],
  "profile.appearance": ["Görüntü Ayarları", "Görünüm", "Görüntü ve Saat"],
  "profile.timeDate": ["Tarih ve Saat", "Saat", "Görüntü ve Saat"],
  payment: ["Ödeme", "Sistem"],
  custom: ["Göz Ayarları", "Göz"],
  general: ["Genel Ayarlar"],
};

// general.<altGrup> yolları SUBGROUPS etiketlerinden türer (Çay, Filtre
// Kahve, Türk Kahvesi, Çay-Filtre Kahve Ortak).
for (const sub of SUBGROUPS) {
  PATH_TITLES[`general.${sub.id}`] = [sub.label, "Genel Ayarlar"];
}

// Anahtar → içinde bulunduğu konu başlıkları (Isıtıcı Ayarı, Kazan Ayarı,
// Çay Demleme Ayarı, Log ...). Konu başlıkları veri ağacında bir düğüm
// değildir, bu yüzden anahtar bazlı tutulur.
const KEY_TITLES = {};
const addKeyTitle = (key, title) => {
  if (!KEY_TITLES[key]) KEY_TITLES[key] = [];
  if (!KEY_TITLES[key].includes(title)) KEY_TITLES[key].push(title);
};
for (const topics of Object.values(TOPICS)) {
  for (const topic of topics) {
    for (const key of topic.keys) addKeyTitle(key, topic.label);
  }
}
for (const key of LOG_KEYS) addKeyTitle(key, "Log");

export const categoryNamesForPath = (path) => PATH_TITLES[path] || [];
export const categoryNamesForKey = (key) => KEY_TITLES[key] || [];

export const anyNameMatches = (names, foldedTerm) =>
  names.some((n) => fold(n).includes(foldedTerm));
